import { motion } from "framer-motion";
import { Mic, MessageSquare, Volume2 } from "lucide-react";
import { EASE, Label } from "./SlideKit";

export const IntroScreen = ({ stage, onBegin, onStart }) => (
  <div className="w-full h-full flex flex-col justify-center px-8 sm:px-16 lg:px-24 relative z-10">
    <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1.1, ease: EASE }}>
      <Label className="text-[#dd6611]">X Scale presents</Label>
    </motion.div>
    <motion.h1
      initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.2, delay: 0.15, ease: EASE }}
      className="text-5xl sm:text-6xl lg:text-7xl font-extralight tracking-tighter text-white mt-8 leading-[0.95]"
    >
      Averra <span className="text-neutral-500">Life</span>
    </motion.h1>
    <motion.div
      initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.1, delay: 0.3, ease: EASE }}
      className="text-lg sm:text-xl font-light text-neutral-400 mt-4"
    >
      An immersive, voice-guided walkthrough of the go-to-market strategy
    </motion.div>

    <motion.div
      initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.1, delay: 0.5, ease: EASE }}
      className="mt-12 grid sm:grid-cols-3 gap-px bg-neutral-800 border border-neutral-800 max-w-3xl"
    >
      {[
        [Volume2, "Voice guided", "Xena, the X Scale Concierge, narrates every slide like a film."],
        [Mic, "Questions at the end", "Xena opens the floor when the story concludes — speak or type, and she answers."],
        [MessageSquare, "Can't wait?", "Tap Ask a Question in the bottom right corner at any time — answers come strictly from the dossier."],
      ].map(([Icon, t, s]) => (
        <div key={t} className="bg-[#050505] p-6">
          <Icon size={18} className="text-[#dd6611]" strokeWidth={1.5} />
          <div className="text-white mt-3 text-sm">{t}</div>
          <div className="text-neutral-500 font-light text-xs mt-2 leading-relaxed">{s}</div>
        </div>
      ))}
    </motion.div>

    <motion.div
      initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.1, delay: 0.7, ease: EASE }}
      className="mt-12"
    >
      {stage !== "ready" ? (
        <div className="flex items-center gap-8">
          <button
            data-testid="begin-presentation-btn"
            onClick={onBegin}
            disabled={stage === "preparing"}
            className="border border-[#dd6611] text-white px-12 py-4 text-lg font-light tracking-wide hover:bg-[#dd6611] hover:text-black transition-colors duration-300 disabled:opacity-60"
          >
            {stage === "preparing" ? (
              <span className="font-mono text-sm tracking-[0.2em] uppercase pulse-dot">Preparing Xena…</span>
            ) : (
              <>Begin the Experience</>
            )}
          </button>
          <Label className="hidden sm:block">
            {stage === "preparing"
              ? "Please allow microphone access when your browser asks"
              : "Step 1 of 2 — your browser will ask for microphone access"}
          </Label>
        </div>
      ) : (
        <motion.div
          initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: EASE }}
          className="flex items-center gap-8"
        >
          <button
            data-testid="start-presentation-btn"
            onClick={onStart}
            className="border border-[#dd6611] bg-[#dd6611] text-black px-12 py-4 text-lg font-light tracking-wide hover:bg-transparent hover:text-white transition-colors duration-300"
          >
            Start Presentation
          </button>
          <Label className="text-[#dd6611]">Xena is ready — press start and she'll begin speaking</Label>
        </motion.div>
      )}
    </motion.div>
  </div>
);
